// Forked into ../../redesign/Results/GroupTags.tsx (the chip click) — keep in sync until phase_0 cleanup.
import React from 'react';
import styled from 'styled-components';
import { Chip, token } from '@bynder/design-system';
import { IconTag } from '@bynder/icons';
import { onTagSearch } from '../../helpers/searchUtils';
import { useNavigableItem } from '../../KeyboardNavigation';
import { getSpotlightResultClassName } from '../../helpers/getSpotlightResultClassName';
import { useSearch, useSearchMode } from '../../SpotlightState';

interface Props {
	tagName: string;
	tagQty: number;
}

export function Tag({ tagName, tagQty }: Props) {
	const { clearResults } = useSearch();
	const { isHybridSearchOn } = useSearchMode();
	const { isActive, itemRef, select } = useNavigableItem<HTMLDivElement>(() =>
		onTagSearch({ isHybridSearchOn, tagName, resetSearch: clearResults }),
	);

	const classNames = `${getSpotlightResultClassName('GENERIC')} ${getSpotlightResultClassName(
		'Tag',
	)}`;

	return (
		<StyledDiv ref={itemRef} className={classNames}>
			<Chip
				onClick={select}
				icon={<IconTag style={{ color: isActive ? undefined : token.gray400 }} />}
				size="s"
			>
				{tagName} {tagQty}
			</Chip>
		</StyledDiv>
	);
}

const MAX_TAG_WIDTH = 200;

// the "> button box-sizing" is needed to nullify the "box-sizing: border-box !important;" set in ResultsDropdown and avoid messing with the Chip's styles
const StyledDiv = styled.div`
	max-width: ${MAX_TAG_WIDTH}px;
	container: inline-size;
	box-sizing: content-box !important;

	> button {
		box-sizing: border-box !important;
	}

	> button * {
		box-sizing: content-box !important;
	}

	@container (min-width: ${MAX_TAG_WIDTH - 1}px) {
		padding: 0 10px;
	}
`;
